import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/context/I18nContext";

const KEY = "mp_cookie_consent";

export function CookieConsent() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setShow(true); } catch {}
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "accepted"); } catch {}
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35, ease: [0.25, 0.1, 0.25, 1] }}
          className="fixed inset-x-3 bottom-3 z-[100] mx-auto max-w-2xl rounded-2xl border border-border/60 bg-card/95 p-4 shadow-lg backdrop-blur-xl sm:inset-x-6 sm:bottom-6"
          data-testid="cookie-consent"
        >
          <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
            <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-sage/15 text-sage">
              <Cookie className="h-5 w-5" strokeWidth={1.5} />
            </div>
            <p className="flex-1 text-sm leading-relaxed text-muted-foreground">
              {t("cookie.msg")}{" "}
              <Link to="/privacy" className="text-primary hover:underline" data-testid="cookie-learn-more">{t("cookie.more")}</Link>
            </p>
            <Button size="sm" className="w-full flex-shrink-0 rounded-full sm:w-auto" onClick={accept} data-testid="cookie-accept-button">
              {t("cookie.accept")}
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
